import * as React from 'react';
import b_ from 'b_';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'shared/components/Link';
import SubItem from './components/SubItem';

import './index.scss';

const b = b_.with('stock-landing-terms');

export const Terms: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="invest-landing-section">
      <h2 className="invest-landing-section__title">{t('Key investment terms and conditions')}</h2>
      <div className="invest-landing__content">
        <div className="invest-landing-dropdown__row">
          <div className="invest-landing-section__column invest-landing-section__column_col-10 invest-landing-section__column_gap-right-3">
            <SubItem title={t('Rights and obligations')}>
              <Trans i18nKey="Stocks rights and obligations">
                The investment conditions and obligations of UT are governed by the
                <Link className={b('link')} to="/offer">
                  offer
                </Link>
                . This document specifies all legal issues.
              </Trans>
            </SubItem>
          </div>
          <div className="invest-landing-section__column invest-landing-section__column_col-11">
            <SubItem title={t('Exchange Hours')}>{t('Stocks Exchange Hours')}</SubItem>
          </div>
        </div>
        <div className="invest-landing-dropdown__row">
          <div className="invest-landing-section__column invest-landing-section__column_col-10 invest-landing-section__column_gap-right-3">
            <SubItem title={t('Purchase conditions')}>{t('Stocks purchase conditions')}</SubItem>
          </div>
          <div className="invest-landing-section__column invest-landing-section__column_col-11">
            <SubItem title={t('Miscellaneous terms')}>{t('Stocks miscellaneous terms')}</SubItem>
          </div>
        </div>
      </div>
    </div>
  );
};
